<template>
  <div class="devices">
    <!-- <van-tabs class="method-navs" v-model="active" line-width="6rem">
      <van-tab :name="1">
        <template #title>
          蓝牙打印机
          <van-loading />
        </template>
      </van-tab>
    </van-tabs> -->
    <p class="page-title">
      <label>蓝牙打印机</label>
      <van-loading />
    </p>

    <div class="device-list">
      <div
        v-for="(item, index) in devices"
        :key="index"
        class="item"
      >
        <div class="left">
          <p class="title">
            设备名称：
          </p>
          <p class="name">
            {{ item.name }}
          </p>
        </div>
        <van-button
          class="btn"
          :class="{ 
            blue: !device || !device.address !== item.address, 
            green: device && device.address === item.address
          }"
          @click="handleClick(item)"
        >{{ device && device.address === item.address ? '已连接' : '连接' }}</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { deviceLocalKey } from '@/config/index';
import { mapActions, mapGetters } from 'vuex';
import {
  Dialog,
  Loading
} from 'vant';
export default {
  name: 'Device',
  components: {
    [Loading.name]: Loading
  },
  data() {
    return {
      active: 1,
      devices: [],
      connectLoading: null,
      retry: 0
    }
  },
  computed: {
    ...mapGetters([ 'device' ])
  },
  methods: {
    ...mapActions(['setDevice']),
    handleClick(item) {
      const {
        address
      } = item

      if (this.device && this.device.address === address) return

      this.connectDevice(item)
    },
    requestDevices() {
      const config = {
        event: 'openBluetooth',
        params: {},
        callback: this.getDevices
      }

      this.$utils.app.sendAppMsg(config)
    },
    getDevices(data) {
      const {
        device
      } = data
      const {
        address
      } = device
      
      if (!this.devices.map(i => i.address).includes(address)) {
        this.devices.push(device)
      }
    },
    async connectDevice(device) {
      const versionStatus = this.$utils.app.limitVersion('1.0.6')
      if (!versionStatus) return
      
      const validate = await this.$utils.device.validatePrinter(device)
      if (!validate) {
        this.$Toast.fail('该设备未绑定到当前用户，请激活后重试')

        return
      }

      const { code: lastConnectStatus, info } = await this.$utils.device.getLastConnectInfo(device)
      if (lastConnectStatus === 2) {
        return
      } else if (lastConnectStatus === 1 && info.device_id) {
        const { created_name, device_brand, device_model } = info
        const confirmed = await this.$utils.confirm({
          title: `打印机已被${created_name}（${device_brand}-${device_model}）连接，是否继续连接？`
        })

        if (!confirmed) return
      }

      const config = {
        event: 'connectDevice',
        params: { device },
        callback: this.connectResult
      }

      this.$utils.app.sendAppMsg(config)
      this.connectLoading = this.$Toast.loading({
        forbidClick: true,
        message: '连接中...'
      })
    },
    connectResult(data) {
      if (this.connectLoading) {
        this.connectLoading.clear()
        this.connectLoading = null
      }
      
      const {
        status,
        device
      } = data
      if (status === 'connectSuccess') {
        this.$Toast.success('连接成功')
        localStorage.setItem(deviceLocalKey, JSON.stringify(device))
        this.setDevice(device)
        this.$utils.device.saveDeviceConnectInfo(device)
      } else if (status === 'connectFail') {
        this.$Toast.fail('连接失败')
      }
    },
    stopBluetoothSearch() {
      const config = {
        event: 'stopSearchBluetooth'
      }

      this.$utils.app.sendAppMsg(config)
    },
    requestAuth() {
      const config = {
        event: 'requestAuth',
        params: {},
        callback: this.requestAuthStatus
      }

      this.$utils.app.sendAppMsg(config)
    },
    checkAuth() {
      const config = {
        event: 'checkAuth',
        params: {},
        callback: this.checkAuthStatus
      }

      this.$utils.app.sendAppMsg(config)
    },
    openAuthSetting(clearAuthStorage = false) {
      const config = {
        event: 'openAuthSetting',
        params: {
          clearAuthStorage
        }
      }

      this.$utils.app.sendAppMsg(config)
    },
    checkAuthStatus(info) {
      // 检查授权时回调处理
      const {
        detail
      } = info

      if (!detail) {
        Dialog.confirm({
          title: '权限确认',
          message: '为了保证蓝牙功能正常使用，需要您授权访问蓝牙和位置信息，是否继续？'
        })
        .then(() => {
          this.requestAuth()
        })
        .catch(() => {
          this.$router.back()
        })
      } else if (detail.filter(i => i == -1).length === detail.length) {
        Dialog.confirm({
          title: '权限确认',
          message: '为了保证蓝牙功能正常使用，需要您授权访问蓝牙和位置信息，是否继续？',
          confirmButtonText: '去授权'
        })
        .then(() => {
          this.openAuthSetting(true)
          this.$router.back()
        })
        .catch(() => {
          this.$router.back()
        })
      } else {
        this.requestAuth()
      }
    },
    requestAuthStatus(info) {
      // 请求授权时回调处理
      const {
        detail
      } = info
      
      if (detail.filter(i => i == 1).length === detail.length) {
        // 用户全部授权
        this.requestDevices()
      } else if (detail.filter(i => i == -1).length === detail.length || this.retry >= 1) {
        Dialog.confirm({
          title: '权限确认',
          message: '为了保证蓝牙功能正常使用，需要您授权访问蓝牙和位置信息，是否继续？(如授权后仍然遇到此提示，请重装app后进行授权)',
          confirmButtonText: '去授权'
        })
        .then(() => {
          this.openAuthSetting()
          this.$router.back()
        })
        .catch(() => {
          this.$router.back()
        })
      } else {
        this.retry += 1
        Dialog.confirm({
          title: '权限确认',
          message: '为了保证蓝牙功能正常使用，需要您授权访问蓝牙和位置信息，是否继续？'
        })
        .then(() => {
          this.requestAuth()
        })
        .catch(() => {
          this.$router.back()
        })
      }
    }
  },
  mounted() {
    this.checkAuth()
  },
  beforeDestroy() {
    this.stopBluetoothSearch()
  }
}
</script>

<style lang="less" scoped>
  .page-title {
    display: flex;
    align-items: center;
    margin: 0 0 12px;
    label {
      font-size: 48px;
      color: @primary-font-color-2;
      padding: 12px 12px 12px 120px;
    }
    .van-loading {
      width: 50px;
      height: 50px;
      margin: 0 0 0 10px;
      color: #fff;
    }
  }
  .devices {
    display: flex;
    flex-direction: column;
    .method-navs {
      padding: 0 150px;
      margin: 100px 0 102px;
      /deep/ .van-tab {
        flex: none !important;
        margin: 0 0 0 100px;
        padding: 0;
        .van-tab__text {
          display: flex;
        }
        &:first-child {
          margin: 0 !important;
          .van-loading {
            width: 50px;
            height: 50px;
            margin: 0 0 0 10px;
            color: #fff;
          }
        }
      }
      /deep/ .van-tab--active {
        color: #fff !important;
      }
      /deep/ .van-tabs__line {
        display: none;
        // background-image: linear-gradient(to right, @primary-color-3, @primary-color-4);
      }
    }

    .device-list {
      flex: 1;
      overflow-x: hidden;
      overflow-y: auto;
      padding: 0 106px 100px;
      display: flex;
      flex-direction: column;
      // gap: 42px;
      .flexgap(42px, column);
      .item {
        background-image: url('~@/assets/image/device/device-item-bg.png');
        background-size: 100% 100%;
        padding: 56px 60px;
        border-radius: 2px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .left {
          font-size: 42px;
          color: @font-black-2;
          display: flex;
          flex-direction: column;
          // gap: 28px;
          .flexgap(28px, column);
          p {
            word-break: break-all;
          }
        }
        .btn {
          color: #fff;
          flex-shrink: 0;
          width: 230px;
          margin: 0 0 0 10px;
          &.blue {
            border-color: @primary-color-2;
            background-color: @primary-color-2;
          }
          &.green {
            border-color: @primary-color-1;
            background-color: @primary-color-1;
          }
        }
      }
    }
  }
</style>